import ApiRequest from "../index"

const complementsModoManutencao ={
    get: async data => ApiRequest.get(`/v2/lojinha/complements/placeholders`),
    put: async data => ApiRequest.put(`/v2/lojinha/complements/placeholders`,{...data}),
}

export default complementsModoManutencao